import { render, staticRenderFns } from "./FeedbackExterno.vue?vue&type=template&id=e96e6998&scoped=true"
import script from "./FeedbackExterno.vue?vue&type=script&lang=js"
export * from "./FeedbackExterno.vue?vue&type=script&lang=js"
import style0 from "./FeedbackExterno.vue?vue&type=style&index=0&id=e96e6998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96e6998",
  null
  
)

export default component.exports